import React, { Component } from 'react';
import { Form, Modal, message, Input } from 'antd';
import lodash from 'lodash';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
const api = services.api;
const { debounce } = lodash;

class Sendgoods extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            pickupModalVisible: false,
            currentSendOrderNo: '',
            loading: false,
        };
        // 防止“确定”重复点击导致多次请求
        this.handlePickupOkDebounced = debounce(this.handlePickupOk.bind(this), 500);
    }

    // 显示取货码输入弹窗
    showPickupModal = (sendOrderNo) => {
        this.setState({
            pickupModalVisible: true,
            currentSendOrderNo: sendOrderNo,
        });
        // 重置表单
        this.props.form.resetFields();
    };

    // 处理取货码弹窗确认
    handlePickupOk = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.loading) return; // 已在请求中，避免重复
                this.setState({ loading: true });
                let value;
                value = {
                    pick_code: values.pick_code,
                    send_order_no: this.props.rows.sendOrderNo,
                };
                api.get(value, { apiPath: `/8001/order/self_pick_up` })
                    .then(() => {
                        message.success('取货成功');
                        this.setState({ pickupModalVisible: false });
                        setTimeout(() => {
                            // 列表数据刷新
                            this.props.entity.search({
                                ...this.props.entity.filters,
                            });
                        }, 200);
                    })
                    .catch(errorHandle)
                    .finally(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    };

    // 处理取货码弹窗取消
    handlePickupCancel = () => {
        this.setState({
            pickupModalVisible: false,
            currentSendOrderNo: '',
        });
    };

    render() {
        const {
            rows: { deliveryStatus, sendOrderNo },
        } = this.props;
        const { pickupModalVisible, loading } = this.state;
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                {deliveryStatus == 1 && (
                    <a target="_blank" onClick={() => this.showPickupModal(sendOrderNo)}>
                        自提
                    </a>
                )}

                {/* 取货码输入弹窗 */}
                <Modal
                    title="输入取货码"
                    visible={pickupModalVisible}
                    onOk={this.handlePickupOkDebounced}
                    onCancel={this.handlePickupCancel}
                    confirmLoading={loading}
                    okText="确定"
                    cancelText="取消"
                >
                    <Form>
                        <Form.Item label="输入取货码:" required>
                            {getFieldDecorator('pick_code', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入取货码',
                                    },
                                ],
                            })(<Input placeholder="请输入取货码" style={{ width: '100%' }} />)}
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(Sendgoods);
